import {createReducer} from '@reduxjs/toolkit'
import {SiteSettings} from '../../../../commons/types/state'
import {updateSiteSettings} from '../actions/site-settings'

const defaultState: SiteSettings = {} as SiteSettings

export const siteSettings = createReducer(defaultState, builder => {
  builder.addCase(updateSiteSettings.fulfilled, (_, action) => action.payload.settings)
})
